import {
  booleanAttribute,
  Component,
  Input,
  ViewChild,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexXAxis,
  ApexFill,
  ApexTooltip,
  ApexTitleSubtitle,
  ApexGrid,
  ApexResponsive,
  ApexAnnotations,
} from "ng-apexcharts";

export type MarkerShapeOptions =
  | "circle"
  | "square"
  | "rect"
  | "line"
  | "cross"
  | "plus"
  | "star"
  | "sparkle"
  | "diamond"
  | "triangle";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  grid: ApexGrid;
  annotations: ApexAnnotations;
  colors: string[]; 
};

export interface BarGraphDataProps extends ApexAxisChartSeries { }
export interface Annotations {
  yaxis: [
    {
      y: string;
      borderColor: string;
      label: {
        text: string;
        style: {
          color: string;
          background: string;
          fontSize: string;
        };
      };
    }
  ];
}

@Component({
  selector: "app-bar-graph",
  templateUrl: "./bar-graph.component.html",
  styleUrl: "./bar-graph.component.scss",
})
export class BarGraphComponent implements OnInit, OnChanges {
  @ViewChild("chart") chart!: ChartComponent;
  public chartOptions!: Partial<ChartOptions>;

  @Input({ required: true }) chart_type!: "bar" | "line" | "area";
  @Input({ required: true }) xAxis!: string[];
  @Input() xAxisTitle: string;
  @Input() yAxisTitle: string;
  @Input() title: string = "";
  @Input() titleAlign: "left" | "center" | "right" = "left";
  @Input() LegendPosition: "top" | "right" | "bottom" | "left" = "bottom";
  @Input() horizontalAlign: "left" | "center" | "right" = "left";
  @Input() markerShape: MarkerShapeOptions = "line";
  @Input() gridY: boolean = true;
  @Input() gridX: boolean = false;
  @Input({ transform: booleanAttribute }) showXlabel: boolean = true;
  @Input({ transform: booleanAttribute }) showYlabel: boolean = true;
  @Input() width: string;
  @Input() threshold: Annotations;
  @Input() colors: string[] = ["#7f8bfa"];

  @Input() data: BarGraphDataProps;
  @Input() height: number = 350;
  @Input() columnWidth: string = "55%";
  @Input({ transform: booleanAttribute }) horizontal: boolean = false;
  constructor() { }


  ngOnChanges(changes: SimpleChanges): void {

    this.loadGraph()
  }

  ngOnInit(): void {
    this.loadGraph();
  }

  loadGraph() {
    this.chartOptions = {
      series: this.data,
      chart: {
        type: this.chart_type,
        height: this.height,
        width: this.width,
        zoom: { enabled: true },
        toolbar: { show: false },
        animations: {
          enabled: false,
          dynamicAnimation: {
            enabled: false
          }
        },

      },
       colors: this.colors, 
      plotOptions: {
        bar: {
          horizontal: this.horizontal,
          columnWidth: this.columnWidth,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        title: {
          text: this.xAxisTitle,
        },
        categories: this.xAxis,
        labels: {
          show: this.showXlabel,
        },
      },
   yaxis: {
  title: {
    text: this.yAxisTitle,
  },
  labels: {
    show: this.showYlabel,
  },
},
      fill: {
        opacity: 1,
      },
      title: {
        text: this.title,
        align: this.titleAlign,
        offsetY: 10,
        margin: 10,
        style: {
          fontSize: "15",
          fontWeight: "bold",
        },
      },
      grid: {
        show: true,

        xaxis: {
          lines: {
            show: this.gridX,
          },
        },
        yaxis: {
          lines: {
            show: this.gridY,
          },
        },
      },

      tooltip: {},
      legend: {
        show: true,
        position: this.LegendPosition,
        horizontalAlign: this.horizontalAlign,
        floating: false,

        markers: {
          shape: this.markerShape,
          strokeWidth: 3,
        },
      },
      annotations: this.threshold,
    };
  }
}
